import React, { useState } from 'react';

interface InsertMeasuresDialogProps {
  isOpen: boolean;
  measureIndex: number;
  onClose: () => void;
  onInsert: (afterMeasureIndex: number, count: number) => void;
}

const InsertMeasuresDialog: React.FC<InsertMeasuresDialogProps> = ({
  isOpen,
  measureIndex,
  onClose,
  onInsert,
}) => {
  const [count, setCount] = useState(1);

  const handleInsert = () => {
    if (count > 0 && count <= 50) { // Reasonable limit
      onInsert(measureIndex, count);
      onClose();
      setCount(1); // Reset for next time
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleInsert();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-96 max-w-sm mx-4 shadow-xl">
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
          Insert Measures
        </h3>
        
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
          Insert new measures after <strong>Measure {measureIndex + 1}</strong>
        </p>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Number of measures to insert:
          </label>
          <input
            type="number"
            min="1"
            max="50"
            value={count}
            onChange={(e) => setCount(parseInt(e.target.value) || 1)}
            onKeyDown={handleKeyDown}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md 
                     bg-white dark:bg-gray-700 text-gray-900 dark:text-white
                     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            autoFocus
          />
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white
                     border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700
                     transition-colors duration-200"
          >
            Cancel
          </button>
          <button
            onClick={handleInsert}
            disabled={count < 1 || count > 50}
            className="px-4 py-2 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 
                     text-white rounded-md transition-colors duration-200
                     disabled:cursor-not-allowed"
          >
            Insert {count} Measure{count !== 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsertMeasuresDialog;